import React from "react";
import { SESSION_PRICE } from "../../../data/mentorshipData";
import { Avatar, VerifiedIcon } from "./MentorParts";

const FoundersCard = ({ founders, onOpen }) => {
  if (founders.length === 0) return null;

  return (
    <div className="ms-card ms-founders">
      <div className="ms-label ms-eyebrow">Founding mentors</div>
      {founders.map((mentor) => (
        <div key={mentor.id} className="ms-founder-row">
          <Avatar mentor={mentor} size={44} />
          <div>
            <div className="ms-name">
              {mentor.name} <VerifiedIcon />
            </div>
            <div className="ms-cred">{mentor.cred}</div>
            <div className="ms-tag">{mentor.tag}</div>
          </div>
        </div>
      ))}
      <button
        type="button"
        className="ms-btn ms-btn--primary ms-btn--lg ms-btn--block"
        onClick={() => onOpen(founders[0].id)}
      >
        Book a call with a founder · ${SESSION_PRICE}
      </button>
    </div>
  );
};

export default FoundersCard;
